import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { config } from '../config';

@Injectable({
  providedIn: 'root'
})
export class TestedIndividualService {

  constructor(private http: HttpClient) { }

  addCandidate(data: any): Observable<any> {
    console.log("Adding clients", data);

    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.post(config.baseApiUrl + "tested-individual", data).subscribe((res: any) => {

        observer.next(res.data);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });

  }

  editCandidate(data: any): Observable<any> {
    console.log("Adding clients", data);

    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.put(config.baseApiUrl + "tested-individual", data).subscribe((res: any) => {

        observer.next(res.data);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });

  }

  getListByJobId(jobId) {
    console.log("Getting clients");
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "tested-individual?mpJob=" + jobId).subscribe((res: any) => {
        console.log("Get clients : ", res);
        observer.next(res.data);
        observer.complete();
      })

    });
  }

  getTestedIndividual(id) {
    console.log("Getting tested individuals");
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "tested-individual?_id=" + id).subscribe((res: any) => {
        console.log("Get TESTED INDIVIDUAL : ", res);
        observer.next(res.data.users);
        observer.complete();
      })

    });
  }

  deleteTestedIndividual(id) {
    return new Observable((observer) => {
      this.http.delete(config.baseApiUrl + "tested-individual?_id=" + id).subscribe((res: any) => {
        observer.next(res.data);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        });

    })
  }
}
